<template>

  <div class="base_box">
    <el-upload class="avatar-uploader" action="http://localhost:8080/api/file/uploadFile" :headers="myheader" :with-credentials="true" :show-file-list="true" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-remove="RemoveImg">
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div @click="RemoveImg">

      del
    </div>
  </div>
</template><script>
export default {
  data() {
    return {
      imageUrl: "",
      myheader: {
        operator: "111111",
      },

      delImg: "",
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res);
      console.log(file);
      this.delImg = res.message;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    RemoveImg() {
      this.$Loading.show();
      let pardata = {
        fileList: this.delImg,
      };
      this.http.From("/file/deleteFile", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
        } else {
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  border: 1px solid red;
}
</style>